import TwoFactorStep from './TwoFactorStep.component';

export default TwoFactorStep;
